import { useContext } from "react"
import {
  post_add_trace_orders,
  post_execute_actions_orders,
  put_update_info_order_action,
} from "services/middleware_services"
import AuthContext from "store/context/PublicContext"

const UseShippingGroupActions = () => {
  const {
    user: { token },
  } = useContext(AuthContext)

  const postAddTraceShippingGroup = async (orderId: string, body: any) => {
    const res = await post_add_trace_orders(orderId, body, token)
    return res
  }

  const postMultipleExecuteActionShippingGroup = async (body: any) => {
    const res = await post_execute_actions_orders(body, token)
    return res
  }

  const putUpdateInfoOrderAction = async (id: string, body: any) => {
    const res = await put_update_info_order_action(id, body, token)
    return res
  }

  return {
    postAddTraceShippingGroup,
    postMultipleExecuteActionShippingGroup,
    putUpdateInfoOrderAction,
  }
}

export default UseShippingGroupActions
